export const style = {
  h3: {
    fontSize: `24px`,
    fontWeight: 300,
    lineHeight: `24px`,
    color: `black`,
    margin: `0 0 32px 0`
  },
  strong: {
    fontWeight: 700
  },
  p: {
    fontSize: `14px`,
    fontWeight: 400,
    lineHeight: `22px`,
    margin: `0 0 20px`
  },
  link: {
    color: `#a94545`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/About/style/story.js